import '../css/message.css'
import UserImageRound from '../helpers/UserImage';
import defaultUserImage from '../img/default_chat_user_image.png'

function Message({message, userId, setAnsweredMessage}) {
    return <div className="message">
        <div className='message-user-info'>
            <div className='message-user-image-container'>
                <UserImageRound className='message-user-image' src={message.user.image} alt='error' fallbackSrc={defaultUserImage}/>
            </div>
            <div className='message-user-name'>{message.user.name}</div>
            <div className='message-user-id'>ID {message.user.id}</div>
        </div>
        <div className='message-text-container' style={{backgroundColor: userId !== message.user.id ? '#F2F4F5' : '#6B4EFF'}} onClick={() => setAnsweredMessage(message)}>
            {message.is_answered && <div className='message-answered-message'>
                <div className='message-answered-message-user'>В ответ ID {message.answered_message.user.id}</div>
                <div className='message-answered-message-text'>{message.answered_message.text}</div>
            </div>}
            <div className='message-text' style={{color: userId !== message.user.id ? '#090A0A' : '#FFFFFF', whiteSpace: 'pre-line'}}>{message.text}</div>
        </div>
    </div>
};

export default Message;